export default "__VITE_ASSET__DaLAAfJI__"